// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var File = function File(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15 18.125a.627.627 0 0 0 .625-.625V6.25H12.5c-.691 0-1.25-.559-1.25-1.25V1.875H5a.627.627 0 0 0-.625.625v15c0 .344.281.625.625.625zM2.5 2.5C2.5 1.121 3.621 0 5 0h6.465c.664 0 1.3.262 1.77.73l3.535 3.536a2.5 2.5 0 0 1 .73 1.77V17.5c0 1.379-1.121 2.5-2.5 2.5H5a2.5 2.5 0 0 1-2.5-2.5z"
  }));
};
